import { createRouter, createWebHistory } from 'vue-router'
import { getToken } from '@/utils/auth'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/power.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/HomeView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/about',
    name: 'about',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/cockpit',
    name: 'cockpit',
    component: () => import('../views/cockpit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/power',
    name: 'power',
    component: () => import('../views/power.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/beltTransport',
    name: 'beltTransport',
    component: () => import('@/views/beltTransport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/promote',
    name: 'promote',
    component: () => import('@/views/promote.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/historyData',
    name: 'historyData',
    component: () => import('@/views/historyData.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/compressedAir',
    name: 'compressedAir',
    component: () => import('@/views/compressedAir.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/adminLogin',
    name: 'adminLogin',
    component: () => import('@/views/adminLogin.vue'),
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/user.vue'),
    meta: { requiresAuth: true },
  },
  // 404页面路由
  {
    path: '/404',
    name: 'notFound',
    component: () => import('@/views/NotFound.vue'),
  },
  // 通配符路由，必须放在最后
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// 路由守卫 - 检查登录状态
router.beforeEach((to, from, next) => {
  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const accessToken = getToken()
    if (!accessToken) {
      next({
        path: '/login',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
